export default "__VITE_ASSET__CD5K$6H4__"